// Register service worker for cache management
export const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      // Add a unique timestamp to prevent cache hits
      const cacheBuster = Date.now();
      
      navigator.serviceWorker.register(`/service-worker.js?v=${cacheBuster}`)
        .then(registration => {
          console.log('Service Worker registered with scope:', registration.scope);
          
          // Force update check on registration, but with a delay
          setTimeout(() => {
            registration.update()
              .catch(err => console.error('Error updating service worker:', err));
          }, 10000); // 10 second delay
          
          // Add update detection when service worker changes
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            console.log('New service worker state:', newWorker.state);
            
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                console.log('New service worker installed, update available');
                // New service worker is installed, notify the application
                window.dispatchEvent(new CustomEvent('serviceWorkerUpdated'));
              }
            });
          });
          
          // Set up periodic service worker updates - but much less frequently
          setInterval(() => {
            console.log('Checking for service worker updates...');
            registration.update()
              .catch(err => console.error('Error updating service worker:', err));
          }, 6 * 60 * 60 * 1000); // Check every 6 hours instead of every hour
        })
        .catch(error => {
          console.error('Service Worker registration failed:', error);
        });
        
      // Set up a listener for controlling service worker changes
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        console.log('Service worker controller changed, possible update');
        // Don't dispatch event immediately to prevent refresh loops
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent('serviceWorkerUpdated'));
        }, 5000);
      });
    });
  }
};

// Check version through service worker
export const checkVersionThroughServiceWorker = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.serviceWorker || !navigator.serviceWorker.controller) {
      reject(new Error('Service worker not active'));
      return;
    }
    
    // Setup message handler
    const messageHandler = (event) => {
      if (event.data && event.data.action === 'VERSION_INFO') {
        navigator.serviceWorker.removeEventListener('message', messageHandler);
        resolve({
          version: event.data.version,
          buildTimestamp: event.data.buildTimestamp,
          buildId: event.data.buildId,
          deployTime: event.data.deployTime
        });
      }
    };
    
    // Listen for the response
    navigator.serviceWorker.addEventListener('message', messageHandler);
    
    // Send message to service worker to check version
    navigator.serviceWorker.controller.postMessage({
      action: 'CHECK_VERSION',
      timestamp: Date.now() // Include timestamp to prevent caching
    });
    
    // Set timeout to avoid endless waiting
    setTimeout(() => {
      navigator.serviceWorker.removeEventListener('message', messageHandler);
      reject(new Error('Version check timed out'));
    }, 5000);
  });
};

// Clear caches through service worker
export const clearCachesThroughServiceWorker = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.serviceWorker || !navigator.serviceWorker.controller) {
      reject(new Error('Service worker not active'));
      return;
    }
    
    // Setup message handler
    const messageHandler = (event) => {
      if (event.data && event.data.action === 'CACHES_CLEARED') {
        navigator.serviceWorker.removeEventListener('message', messageHandler);
        resolve(true);
      }
    };
    
    // Listen for the response
    navigator.serviceWorker.addEventListener('message', messageHandler);
    
    // Send message to service worker to clear caches
    navigator.serviceWorker.controller.postMessage({
      action: 'CLEAR_CACHES',
      timestamp: Date.now() // Include timestamp to prevent caching
    });
    
    // Set timeout to avoid endless waiting
    setTimeout(() => {
      navigator.serviceWorker.removeEventListener('message', messageHandler);
      reject(new Error('Cache clearing timed out'));
    }, 5000);
  });
};

// Force service worker update check
export const checkForServiceWorkerUpdate = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.serviceWorker || !navigator.serviceWorker.controller) {
      reject(new Error('Service worker not active'));
      return;
    }
    
    // Setup message handler
    const messageHandler = (event) => {
      if (event.data && event.data.action === 'UPDATE_CHECKED') {
        navigator.serviceWorker.removeEventListener('message', messageHandler);
        resolve(true);
      }
    };
    
    // Listen for the response
    navigator.serviceWorker.addEventListener('message', messageHandler);
    
    // Send message to service worker to check for updates
    navigator.serviceWorker.controller.postMessage({
      action: 'CHECK_AND_UPDATE',
      timestamp: Date.now()
    });
    
    // Set timeout to avoid endless waiting
    setTimeout(() => {
      navigator.serviceWorker.removeEventListener('message', messageHandler);
      reject(new Error('Update check timed out'));
    }, 5000);
  });
}; 